module.exports = __webpack_public_path__ + "static/media/le-dauphine-libere.46e65f50.jpg";